import "core-js/modules/es6.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import TeDialog from 'src/components/Dialogs/TEDialog';
import PhaseCategory from 'src/store/models/PhaseCategory';
import ColorPicker from 'src/components/Pickers/Color';
import { dialog } from 'src/boot/mixins.js';
import { each } from 'lodash';
import { colorUtils } from 'src/mixins/colors-utils';
export default {
  mixins: [dialog, colorUtils],
  components: {
    TeDialog: TeDialog,
    ColorPicker: ColorPicker
  },
  data: function data() {
    return {
      phaseCategories: [],
      isDirty: false,
      loading: true
    };
  },
  watch: {
    phaseCategories: {
      deep: true,
      handler: function handler(val, oldVal) {
        if (!this.isDirty && oldVal.length) {
          this.isDirty = true;
        }
      }
    }
  },
  methods: {
    addNew: function addNew() {
      this.phaseCategories.unshift({
        color: this.getRandomColor(),
        // get random color
        name: null,
        phases_count: 0
      });

      if (this.$refs.scrollArea) {
        this.$refs.scrollArea.setScrollPosition(0);
      }
    },
    markForDeletion: function markForDeletion(phaseCategory, index) {
      if (phaseCategory.task_category_id) {
        phaseCategory.delete = true;
      } else {
        this.phaseCategories.splice(index, 1);
      }
    },
    undoDeletion: function undoDeletion(phaseCategory, index) {
      phaseCategory.delete = false;
    },
    validate: function validate() {
      var valid = true;
      var validatedArray = [];
      each(this.phaseCategories, function (phaseCategory) {
        if (!phaseCategory.name || phaseCategory.name === '') {
          phaseCategory.error = true;
          valid = false;
        } else {
          phaseCategory.error = false;
        }

        validatedArray.push(phaseCategory);
      });
      this.phaseCategories = validatedArray;
      return valid;
    },
    loadPhaseCategories: function loadPhaseCategories() {
      var _this = this;

      this.loading = true;
      PhaseCategory.api().get('/phase-categories').then(function (result) {
        var phaseCategories = result.response.data.data;
        each(phaseCategories, function (phaseCategory) {
          phaseCategory.delete = false;
        });
        _this.phaseCategories = phaseCategories;
        _this.loading = false;
      }).catch(function () {
        _this.loading = false;
      });
    },
    savePhaseCategories: function savePhaseCategories() {
      var _this2 = this;

      if (this.validate()) {
        this.loading = true;
        PhaseCategory.api().post('/phase-categories/mass-update', {
          phase_categories: this.phaseCategories
        }).then(function (result) {
          _this2.$q.notify({
            message: _this2.$t('components.phaseCategoriesDialog.phase_category_saved'),
            type: 'positive'
          });

          _this2.loading = false;

          _this2.hide();
        }).catch(function () {
          _this2.$q.notify({
            message: _this2.$t('components.dialphaseCategoriesDialogogs.error_saving_phase'),
            type: 'negative'
          });

          _this2.loading = false;
        });
      } else {
        this.$q.notify({
          message: this.$t('components.phaseCategoriesDialog.missing_field_name'),
          type: 'warning'
        });
      }
    }
  },
  mounted: function mounted() {
    this.loadPhaseCategories();
  }
};